module.exports = __webpack_public_path__ + "static/media/CONFIRM_LOADING_THE_CONTAINER.38595824.svg";